module.exports = __webpack_public_path__ + "static/media/leave_the_nest.2a16483f.webp";